import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import Cutter1 from './Cutter1.js';
import Cutter2 from './Cutter2.js';
import Folder1 from './Folder1.js';
import Folder2 from './Folder2.js';
import Folder3 from './Folder3.js';
import Lilblue from './Lilblue.js';
import Stitcher from './Stitcher.js';
import Handwork from './Handwork.js';
import Cutter3 from './Cutter3.js';
import Shrinkwrap from './Shrinkwrap.js';

const Schedules = () => {
  const [showportal3, setShowportal3] = useState(false);
  const [events, setEvents] = useState([]);
  const [mergedJobs, setMergedJobs] = useState({ all: [], cutting: [], folding: [], stitching: [], shrinkwrap: [], handwork: [] });
  const [activeTab, setActiveTab] = useState(localStorage.getItem('scheduletabs1') || 0);
  const [operations, setOperations] = useState([]);
  const [jobNumbers, setJobNumbers] = useState([]);
  const [initialMergedData, setInitialMergedData] = useState([]);
  const [hasUpdatedMergedJobs, setHasUpdatedMergedJobs] = useState(false);
  const [reset, setReset] = useState(false);
  const [activejobs, setActivejobs] = useState([]);
  const api = 'https://highgroundapi.herokuapp.com';
     // const api = 'https://localhost:5001';
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  };

  // Fetch operations data
  const getops = async (jobNumbers) => {
    try {
      let r = { 'jobs': jobNumbers };
   
      const response = await axios.post(
        'https://highgroundsoftware.com/dash/dashboard/php/getbinderyops.php',
        r,
        config
      );

      setOperations(response.data);
    } catch (err) {
      console.error('Error fetching operations:', err);
      setOperations([]);
    }
  };

  // Fetch jobs data
  useEffect(() => {
    const mergeActiveAndEstData = async () => {
    
      try {
        // Fetch schedule data first
        const scheduleResponse = await axios.post(`${api}/sched/get`);
   
        const scheduledJobs = scheduleResponse.data.map(event => ({
          job: event?.job,
          component: event.component
        }));
     

        const activeResponse = await axios.post(
          'https://highgroundsoftware.com/dash/dashboard/php/getactivejobs.php',
          { job: '123456' },
          config
        );
        setActivejobs(activeResponse.data);

        const activeJobIds = activeResponse.data.map(item => String(item.quote));

        const estResponse = await axios.post(
          'https://highgroundsoftware.com/dash/dashboard/php/getbinderyimpo.php',
          { 'quotes': activeJobIds },
          config
        );

        const estData = estResponse.data;
      
        const mergedData = estData
          .filter(estItem => activeJobIds.includes(String(estItem.quote)))
          .map(estItem => {
            const activeItem = activeResponse.data.find(active => String(active.quote) === String(estItem.quote));
            return {
              ...estItem,
              ...activeItem,
              totalCuthrs: parseFloat(estItem.cuthrs1 || 0) + parseFloat(estItem.cuthrs2 || 0),
              component: estItem.component,
              duedate: activeItem?.duedate || null,
              uuid: uuidv4()
            };
          })
          .filter(estItem => 
            !scheduledJobs.some(sched => 
              sched.job === estItem.job && sched.component === estItem.component
            )
          );

        // Extract job numbers
        const jobs = mergedData.map(item => String(item.job));
        setJobNumbers(jobs);
        setInitialMergedData(mergedData);
      } catch (error) {
  
        setMergedJobs({
          all: [],
          cutting: [],
          folding: [],
          stitching: [],
          shrinkwrap: [],
          handwork: []
        });
        setJobNumbers([]);
        setInitialMergedData([]);
      }
    };

    mergeActiveAndEstData();
  }, [reset]);

  // Fetch operations and update mergedJobs
  useEffect(() => {
    if (jobNumbers.length > 0 && !hasUpdatedMergedJobs) {
      getops(jobNumbers);
    }
    if (operations.length > 0 && initialMergedData.length > 0 && !hasUpdatedMergedJobs) {
      const jobsWithOps = new Set(operations.map(op => String(op.job)));
      const filteredMergedData = initialMergedData.filter(item => jobsWithOps.has(String(item.job)));

      const updatedMergedData = filteredMergedData.map(item => {
        const operation = operations.find(op => String(op.job) === String(item.job));
        return {
          ...item,
          status: operation ? operation.name : null
        };
      });

      // Build arrays independently
      const cutting = [];
      const folding = [];
      const stitching = [];
      const shrinkwrap = [];
      const handwork = [];
      const uniqueJobs = {
        stitching: new Set(),
        shrinkwrap: new Set(),
        handwork: new Set()
      };

      updatedMergedData.forEach(item => {
        // Add to cutting if cuts > 0
        if (Number(item.cuts) > 0) {
          cutting.push({ ...item, totalCuthrs: item.totalCuthrs, component: item.component });
        }

        // Add to folding if numfolds > 0
        if (Number(item.numfolds) > 0) {
          folding.push({ ...item, totalCuthrs: item.totalCuthrs, component: item.component });
        }

        // Add to stitching if stitchpockets > 0 or stitchup > 0, deduplicate by job
        if (Number(item.stitchpockets) > 0 || Number(item.stitchup) > 0) {
          if (!uniqueJobs.stitching.has(String(item.job))) {
            uniqueJobs.stitching.add(String(item.job));
            stitching.push({ ...item, totalCuthrs: 1, component: item.component });
          }
        }

        // Add to shrinkwrap if bundletype is "Shrink Wrap", deduplicate by job
        if (item.bundletype === "Shrink Wrap") {
          if (!uniqueJobs.shrinkwrap.has(String(item.job))) {
            uniqueJobs.shrinkwrap.add(String(item.job));
            shrinkwrap.push({ ...item, totalCuthrs: item.totalCuthrs, component: item.component });
          }
        }

        // Add to handwork if handwork > 0, deduplicate by job
        if (Number(item.handwork) > 0) {
          if (!uniqueJobs.handwork.has(String(item.job))) {
            uniqueJobs.handwork.add(String(item.job));
            handwork.push({ ...item, totalCuthrs: item.handwork, component: item.component });
          }
        }
      });

      setMergedJobs({
        all: updatedMergedData,
        cutting,
        folding,
        stitching,
        shrinkwrap,
        handwork
      });
      setHasUpdatedMergedJobs(true);
    }
  }, [jobNumbers, operations, initialMergedData, hasUpdatedMergedJobs, reset]);

  // Fetch events for the active machine
  const fetchEvents = async (machine) => {
    try {
      const response = await axios.post(`${api}/sched/get`);

      response.data.forEach((event, index) => {
      });
      setEvents(response.data.map(event => ({
        id: event.id,
        title: event.title,
        start: event.start,
        end: event.end,
        machine: event.machine,
        hours: calculateHours(event.start, event.end),
        extendedProps: {
          itemData: event.itemData,
          cuts: event.cuts,
          cuthrs: event.cuthrs,
          component: event.component,
          job: event.job,
          duedate: event.duedate || null,
          _id: event._id
        }
      })));
    } catch (error) {
      console.error('Error fetching events:', error);
      setEvents([]);
    }
  };

  useEffect(() => {
    const machine = getMachineFromTab(activeTab);
    fetchEvents(machine);
  }, [activeTab]);

  // Function to filter events by machine
  const filterEventsByMachine = (machine) => {
    return events.filter((event) => event.machine === machine);
  };

  // Function to update event times
  const updateEvent = (eventId, newStart, newEnd, itemData, cuts, cuthrs, component, job, dbid, duedate) => {
    setEvents((prevEvents) => {
      const existingEvent = prevEvents.find(event => event.id === eventId);
  
      if (existingEvent) {
        // Update existing event
        return prevEvents.map((event) =>
          event.id === eventId
            ? {
                ...event,
                start: newStart,
                end: newEnd,
                hours: calculateHours(newStart, newEnd),
                extendedProps: {
                  ...event.extendedProps,
                  itemData,
                  cuts,
                  cuthrs,
                  component,
                  job,
                  duedate,
                  _id: dbid
                }
              }
            : event
        );
      } else {
        // Add new event
        return [
          ...prevEvents,
          {
            id: eventId,
            start: newStart,
            end: newEnd,
            hours: calculateHours(newStart, newEnd),
            machine: itemData ? itemData.machine : null,
            title: itemData ? `${itemData.customer}\n${itemData.job}-${itemData.numforms}-${component}` : '',
            extendedProps: {
              itemData,
              cuts,
              cuthrs,
              component,
              job,
              duedate,
              _id: dbid
            }
          }
        ];
      }
    });
  };

  // Function to update list by removing dragged item
  const updateList = (machine, job, component) => {
    setMergedJobs((prevJobs) => {
      let updatedArray;
      if (machine?.includes('Cutter')) {
        updatedArray = prevJobs.cutting.filter(item => !(item.job === job && item.component === component));
        return { ...prevJobs, cutting: updatedArray };
      } else if (machine.includes('Folder') || machine === 'Lil Blue') {
        updatedArray = prevJobs.folding.filter(item => !(item.job === job && item.component === component));
        return { ...prevJobs, folding: updatedArray };
      } else if (machine.includes('Stiching')) {
        updatedArray = prevJobs.stitching.filter(item => !(item.job === job && item.component === component));
        return { ...prevJobs, stitching: updatedArray };
      } else if (machine.includes('Shrink Wrap')) {
        updatedArray = prevJobs.shrinkwrap.filter(item => !(item.job === job && item.component === component));
        return { ...prevJobs, shrinkwrap: updatedArray };
      } else if (machine.includes('Hand Bindery')) {
        updatedArray = prevJobs.handwork.filter(item => !(item.job === job && item.component === component));
        return { ...prevJobs, handwork: updatedArray };
      }
      return prevJobs;
    });
    setReset(prev => !prev); // Trigger data refresh
  };

  // Helper function to calculate hours between start and end
  const calculateHours = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    return (endDate - startDate) / (1000 * 60 * 60);
  };

  // Helper function to get machine from tab index
  const getMachineFromTab = (tabIndex) => {
    const machines = [
      'Cutter 1',
      'Cutter 2',
      'Folder 1',
      'Folder 2',
      'Folder 3',
      'Lil Blue',
      'Shrink Wrap',
      'Hand Bindery',
      'Stiching'
    ];
    return machines[tabIndex] || 'Cutter 1';
  };


  return (
    <div style={{ marginTop: '20px' }}>
      <Tabs
        defaultIndex={parseInt(activeTab)}
        onSelect={(index) => {
          localStorage.setItem('scheduletabs1', index);
          setActiveTab(index);
        }}
      >
        <TabList>
          <Tab>Craig</Tab>
          <Tab>Randy</Tab>
               <Tab>Digital Cutter</Tab>
          <Tab>Donald</Tab>
          <Tab>Derrick</Tab>
          <Tab>3rd Wheel</Tab>
          <Tab>Lil Blue</Tab>
          <Tab>Handwork</Tab>
          <Tab>Stitcher</Tab>
        </TabList>

        <TabPanel>
          <Cutter1 
            machine="Cutter 1" 
            events={filterEventsByMachine('Cutter 1')} 
            activejobs={activejobs} 
            updateEvent={updateEvent} 
            list={mergedJobs.cutting} 
            updateList={updateList} 
            fetchEvents={fetchEvents} 
            reset={reset} 
            setReset={setReset}
          />
        </TabPanel>
         <TabPanel>
          <Cutter2 
            machine="Cutter 2" 
            events={filterEventsByMachine('Cutter 2')} 
            activejobs={activejobs} 
            updateEvent={updateEvent} 
            list={mergedJobs.cutting} 
            updateList={updateList} 
            fetchEvents={fetchEvents} 
            reset={reset} 
            setReset={setReset}
          />
        </TabPanel>
         <TabPanel>
          <Cutter3 
            machine="Cutter 3" 
            events={filterEventsByMachine('Cutter 3')} 
            activejobs={activejobs} 
            updateEvent={updateEvent} 
            list={mergedJobs.cutting} 
            updateList={updateList} 
            fetchEvents={fetchEvents} 
            reset={reset} 
            setReset={setReset}
          />
        </TabPanel>
           <TabPanel>
           <Folder1 
            machine="Folder 1" 
            events={filterEventsByMachine('Folder 1')} 
            activejobs={activejobs} 
            updateEvent={updateEvent} 
            list={mergedJobs.cutting} 
            updateList={updateList} 
            fetchEvents={fetchEvents} 
            reset={reset} 
            setReset={setReset}
          />
        </TabPanel>
           <TabPanel>
           <Folder2 
            machine="Folder 2" 
            events={filterEventsByMachine('Folder 2')} 
            activejobs={activejobs} 
            updateEvent={updateEvent} 
            list={mergedJobs.cutting} 
            updateList={updateList} 
            fetchEvents={fetchEvents} 
            reset={reset} 
            setReset={setReset}
          />
        </TabPanel>
           <TabPanel>
           <Folder3 
            machine="Folder 3" 
            events={filterEventsByMachine('Folder 3')} 
            activejobs={activejobs} 
            updateEvent={updateEvent} 
            list={mergedJobs.cutting} 
            updateList={updateList} 
            fetchEvents={fetchEvents} 
            reset={reset} 
            setReset={setReset}
          />
        </TabPanel>
          <TabPanel>
           <Lilblue
            machine="Lil Blue" 
            events={filterEventsByMachine('Lil Blue')} 
            activejobs={activejobs} 
            updateEvent={updateEvent} 
            list={mergedJobs.cutting} 
            updateList={updateList} 
            fetchEvents={fetchEvents} 
            reset={reset} 
            setReset={setReset}
          />
        </TabPanel>
         <TabPanel>
           <Handwork
            machine="Handwork" 
            events={filterEventsByMachine('Handwork')} 
            activejobs={activejobs} 
            updateEvent={updateEvent} 
            list={mergedJobs.cutting} 
            updateList={updateList} 
            fetchEvents={fetchEvents} 
            reset={reset} 
            setReset={setReset}
          />
        </TabPanel>
           <TabPanel>
           <Stitcher
            machine="Stitcher" 
            events={filterEventsByMachine('Stitcher')} 
            activejobs={activejobs} 
            updateEvent={updateEvent} 
            list={mergedJobs.cutting} 
            updateList={updateList} 
            fetchEvents={fetchEvents} 
            reset={reset} 
            setReset={setReset}
          />
        </TabPanel>
        {/* Other TabPanels remain unchanged */}
      </Tabs>
    </div>
  );
};

export default Schedules;



